import { en, type Catalog } from "./en.ts";
import { ko } from "./ko.ts";

/**
 * Every UI language. Adding one is a catalog file (same keys as en.ts) plus an entry
 * here; `name` is how the language calls itself in the switcher.
 */
export const LOCALES = [
  { code: "en", name: "English", catalog: en },
  { code: "ko", name: "한국어", catalog: ko },
] as const satisfies ReadonlyArray<{ code: string; name: string; catalog: Catalog }>;

export type Locale = (typeof LOCALES)[number]["code"];

export const DEFAULT_LOCALE: Locale = "en";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && LOCALES.some((l) => l.code === value);
}

/** A BCP-47 tag from the browser ("ko-KR", "en-US") to a UI language, by primary subtag. */
export function matchLocale(tag: string | null | undefined): Locale | null {
  if (!tag) return null;
  const lower = tag.toLowerCase();
  if (isLocale(lower)) return lower;
  const primary = lower.split(/[-_]/)[0];
  return isLocale(primary) ? primary : null;
}
